import { render } from "./DefaultAudioDeviceSelector.vue?vue&type=template&id=0605ab26&scoped=true"
import script from "./DefaultAudioDeviceSelector.vue?vue&type=script&lang=js"
export * from "./DefaultAudioDeviceSelector.vue?vue&type=script&lang=js"

import "./DefaultAudioDeviceSelector.vue?vue&type=style&index=0&id=0605ab26&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0605ab26"]])

export default __exports__